module.exports = __webpack_public_path__ + "e5ad1ce440eb7045ecc8d2da9688025e.svg";